import * as model from '../../../../models';
import { TicketAddressActions } from './ticket-address.actions';
import { BoxOfficeActions } from 'app/actions';

export interface TicketAddressState {
	addresses: Record<string, model.Address>
};

const initialState: TicketAddressState  = {
	addresses : {}
};

export const ticketAddressReducer = (state: TicketAddressState = initialState, action): TicketAddressState => {
	switch (action.type) {
		case (TicketAddressActions.SET_ADDRESSES): {
			return Object.assign({}, state, { addresses: action.payload });
		};
		case (TicketAddressActions.UPDATE_ADDRESSES): {
			return Object.assign({}, state, { addresses: action.payload });
		};
		case (BoxOfficeActions.ORDER_PLACED_BO): {
			return Object.assign({}, state, { addresses: initialState.addresses })
		}
		default: return state;
	};
};



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/ticket-address/reducer/ticket-address.reducer.ts